import { Dispatch } from 'react'
import { connect } from 'react-redux'

import Notification, { IStateProps, IDispatchProps, IOwnProps } from './Notification'

import { closeNotification, NotificationsAction } from '../../services/store/actions/notifications/NotificationsAction'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    notification: state.Notifications.notifications[state.Notifications.notifications.length - 1],
  }
}

function mapDispatchToProps(dispatch: Dispatch<NotificationsAction> ): IDispatchProps {
  return {
    closeNotification: (id: string) => dispatch(closeNotification(id)),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(Notification)
